import type { ReactElement } from 'react';
import Collapse from 'react-bootstrap/Collapse';

import OrderHistoryMenu from 'models/OrderHistoryMenu';

import RecipientDetails from './RecipientDetails';
import OrderSummary from './OrderSummary';

function Details({ item }: { item: OrderHistoryMenu }): ReactElement {
  const { areDetailsExpanded } = item;

  return (
    <Collapse in={areDetailsExpanded}>
      <div className="c-order-details">
        <div className="c-order-details__content">
          <div className="row">
            <OrderSummary item={item} />
            <RecipientDetails item={item} />
          </div>
        </div>
      </div>
    </Collapse>
  );
}

export default Details;
